import { Loading } from './styles';

export default Loading;
